export const E2E_GEN_TEST_USER_PREFIX = 'auto-test-user';
export const E2E_GEN_TEST_USER_SUFFIX = '@sparkol.com';
